import { render, staticRenderFns } from "./waitNumber.vue?vue&type=template&id=48aab98b&scoped=true"
import script from "./waitNumber.vue?vue&type=script&lang=js"
export * from "./waitNumber.vue?vue&type=script&lang=js"
import style0 from "./waitNumber.vue?vue&type=style&index=0&id=48aab98b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aab98b",
  null
  
)

export default component.exports